import React from 'react';
import './custom.css';

function Footer() {
  return (
    <footer className='footer'>
      <div className="info-section">
        <div className="bottom-container">
          <h3>Road Traffic Offence Check</h3>
          <span className="horizontal-line"></span>
          <p>
            Empower road user to effortlessly check the status of their motor vehicle and road licence, including any fines and penalties resulting from various offences. 
            We strongly encourage road users to promptly settle their fines and adhere to all rules and regulations for a safer and more compliant driving experience.
          </p>
        </div>

        <div className="bottom-container">
          <h3>Useful Links</h3>
          <span className="horizontal-line"></span>
          <p>
            MOHA <br />
            Police Force <br />
            Loss Report <br />
            Police Clearance <br />
          </p>
        </div>

        <div className="bottom-container">
          <h3>Contact Us</h3>
          <span className="horizontal-line"></span>
          <p>
            TPF ICT <br />
            P.o.Box 961 <br />
            Dodoma, Tanzania <br />
            Phone: 0262323585 <br />
            Email: info.phq@tpf.go.tz <br />
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;